import React from 'react';

// Styles & Assets
import styles from './CheckboxGrid.module.css';

// Components
import CheckboxButton from '../CheckboxButton/CheckboxButton';
import { Column } from '../../../interfaces/Columns';

interface Props<T> {
    columns: Column<T>[]    
    toggleVisibility: (id: number) => void ,
}
const CheckboxGrid = <T,>({columns, toggleVisibility}: Props<T>) => {

    return (
        <div className={styles.listOfOptionsContainer}>
            {columns.map((col, index) =>
                !col.editVisiblilityDisabled &&
                <CheckboxButton
                    key={index}
                    label={col.name()}
                    checked={col.visible}
                    onClick={() => toggleVisibility(col.id)} />)
            }
        </div>
    );
};

export default CheckboxGrid;